import { useState, useEffect } from 'react';

export default function useWebSocket(
  url: string,
  onMessage: (data: string) => void,
  onError: () => void,
  token?: string,
) {
  const [socket, setSocket] = useState<WebSocket | null>(null);
  const [messages, setMessages] = useState<string[]>([]);

  useEffect(() => {
    if (!token) return;

    const ws = new WebSocket(`${url}?token=${token}`);

    ws.onopen = () => {
      console.log('WebSocket Connected');
    };

    ws.onmessage = event => {
      setMessages(prev => [...prev, event.data]);
      onMessage(event.data);
    };
    ws.onerror = error => {
      console.error('WebSocket Error', error);
      onError();
    };
    ws.onclose = () => {
      console.log('WebSocket Disconnected');
    };

    setSocket(ws);

    return () => ws.close();
  }, [url, token]);

  const sendMessage = (message: string) => {
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.send(message);
    }
  };

  return { messages, sendMessage };
}
